export const markAllAsRead = async (chatSessionId, userId, setTotalUnreadCount) =>{
    try {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
    const response = await fetch(`${API_BASE_URL}/api/chat/markAllChatMessagesAsRead`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-SECRET': process.env.REACT_APP_NXTVID_API_SECRET,
      },
      body: JSON.stringify({ chatSessionId, userId }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error response from backend:", errorText);
    }
    const data = await response.json();
    setTotalUnreadCount(prevCount => prevCount - data.count)
    return
  } catch (error) {
    console.error('Error marking chat messages as read', error);
    throw error;
  }
}